import type { MissionListItem } from '@module/apis/client-side/mission/type';
import SettingConfig from '@module/config/setting';
import { useFetchMissionSponListQuery } from '@module/queries/mission/missionQueryHooks';
import formatNumberWithComma from '@module/utils/formatNumberWithComma';
import CloseButton from '@pc/components/atoms/button/CloseButton';
import { Modal } from '@pc/components/modal/modal';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@pc/components/ui/table';

export default function MissionSupportList({ item }: { item: MissionListItem }) {
  const params = {
    missionIdx: item.idx,
  };

  const { data } = useFetchMissionSponListQuery(params);

  return (
    <Modal.Container className='max-h-[600px] w-[368px]'>
      <Modal.Header>
        <Modal.Title className='flex items-center justify-between'>
          <div>미션 후원 목록</div>
          <CloseButton />
        </Modal.Title>
      </Modal.Header>
      <Modal.Content className='mb-0 h-[calc(100%-53px)]'>
        <Table className='mb-0'>
          <TableHeader className='border-t-[2px]'>
            <TableRow className='flex h-[50px] items-center justify-between'>
              <TableHead className='flex basis-3/5 items-center justify-center'>보낸 회원</TableHead>
              <TableHead className='flex basis-2/5 items-center justify-center'>하트개수</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody className='modal-scrollbar-custom block max-h-[451px] overflow-y-auto overflow-x-hidden'>
            {data?.list.map((item, idx) => {
              return (
                <TableRow key={idx} className='flex h-[58px] items-center justify-between'>
                  <TableCell className='basis-3/5 text-left'>
                    <div className='flex gap-[8px] text-[16px]'>
                      <img
                        src={`${SettingConfig.S3_BUCKET_URL}/img/grade/grade_${item.fanLevel}.svg`}
                        alt='grade'
                        width={23}
                      />
                      <span className='text-nowrap'>{item.userNick}</span>
                    </div>
                  </TableCell>
                  <TableCell className='basis-2/5 text-center text-[16px]'>
                    {formatNumberWithComma(item.coin)}개
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Modal.Content>
    </Modal.Container>
  );
}
